"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutContext = void 0;
var react_hooks_1 = require("@apollo/react-hooks");
var braintree_web_1 = __importDefault(require("braintree-web"));
var pick_1 = __importDefault(require("lodash/pick"));
var querystring_1 = __importDefault(require("querystring"));
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
require("../../utils/save-discount-for-checkout");
var save_discount_for_checkout_1 = require("../../utils/save-discount-for-checkout");
var inline_loader_1 = __importDefault(require("../account-v3/components/inline_loader"));
var checkout_steps_1 = __importDefault(require("./components/checkout_steps"));
var order_summary_1 = __importDefault(require("./components/order_summary"));
var scroll_to_top_1 = __importDefault(require("./components/scroll-to-top"));
var mutation_create_checkout_1 = require("./graphql/mutation_create_checkout");
var mutation_update_checkout_1 = require("./graphql/mutation_update_checkout");
var DLEnhancedEcomm = __importStar(require("./helpers/data_layer"));
var CheckoutCookie = __importStar(require("./helpers/login_redirection"));
var transformers_1 = require("./helpers/transformers");
var localization_1 = require("./localization");
var confirmation_1 = __importDefault(require("./steps/confirmation"));
var payment_1 = __importDefault(require("./steps/payment"));
var shipping_address_1 = __importDefault(require("./steps/shipping_address"));
exports.CheckoutContext = (0, react_1.createContext)(null);
var CHECKOUT_TOKEN_LOCALSTORAGE_KEY = 'rechargeCheckoutToken';
var SHOW_BOB_THE_BLOB_LOADING = false;
exports.default = (function (_a) {
    var customer = _a.customer, country = _a.country, cart = _a.cart, defaultAddress = _a.defaultAddress, isPaypalEnabled = _a.isPaypalEnabled, paymentProvider = _a.paymentProvider, paymentAuthorizationToken = _a.paymentAuthorizationToken, signupPageUrl = _a.signupPageUrl, loadingAnimationPath = _a.loadingAnimationPath, defaultMarketingFlag = _a.defaultMarketingFlag, imageUrls = _a.imageUrls, textStrings = _a.textStrings, shippingMethodSubtext = _a.shippingMethodSubtext;
    if (!country)
        return null;
    if (!cart)
        return null;
    if (!paymentProvider)
        return null;
    if (!textStrings)
        textStrings = {};
    var discountCodeErrorMessagesDict = { default: 'Code cannot be applied' };
    try {
        if (textStrings.discountCodeErrorMessages && !discountCodeErrorMessagesDict)
            discountCodeErrorMessagesDict = JSON.parse(textStrings.discountCodeErrorMessages);
    }
    catch (error) {
        console.error('Error parsing discount code error message dictionary', error, textStrings.discountCodeErrorMessages);
        discountCodeErrorMessagesDict = { default: 'Code cannot be applied' };
    }
    CheckoutCookie.clearCheckoutRedirectionCookie();
    var _b = __read((0, react_1.useState)(''), 2), rechargeCheckoutToken = _b[0], setRechargeCheckoutToken = _b[1];
    var _c = __read((0, react_1.useState)(defaultAddress || null), 2), shippingAddress = _c[0], setShippingAddressState = _c[1];
    var _d = __read((0, react_1.useState)(null), 2), billingAddress = _d[0], setBillingAddressState = _d[1];
    var _e = __read((0, react_1.useState)(true), 2), billingSameAsShipping = _e[0], setBillingSameAsShipping = _e[1];
    var _f = __read((0, react_1.useState)(), 2), shippingMethod = _f[0], setShippingMethodState = _f[1];
    var _g = __read((0, react_1.useState)(null), 2), discountCode = _g[0], setDiscountCodeState = _g[1];
    var _h = __read((0, react_1.useState)(null), 2), discountCodeError = _h[0], setDiscountCodeError = _h[1];
    var _j = __read((0, react_1.useState)(null), 2), priceSubtotal = _j[0], setPriceSubtotal = _j[1];
    var _k = __read((0, react_1.useState)(null), 2), priceDiscount = _k[0], setPriceDiscount = _k[1];
    var _l = __read((0, react_1.useState)(null), 2), priceTaxes = _l[0], setPriceTaxes = _l[1];
    var _m = __read((0, react_1.useState)(null), 2), priceTotal = _m[0], setPriceTotal = _m[1];
    var _o = __read((0, react_1.useState)(false), 2), checkoutComplete = _o[0], setCheckoutComplete = _o[1];
    var _p = __read((0, react_1.useState)(0), 2), chargeId = _p[0], setChargeId = _p[1];
    var _q = __read((0, react_1.useState)(false), 2), isPaymentValid = _q[0], setPaymentValid = _q[1];
    var _r = __read((0, react_1.useState)(), 2), paymentInfo = _r[0], setPaymentInfo = _r[1];
    var _s = __read((0, react_1.useState)('creditCard'), 2), paymentMethod = _s[0], setPaymentMethod = _s[1];
    var _t = __read((0, react_1.useState)(), 2), paypalCheckout = _t[0], setPayPalCheckout = _t[1];
    var _u = __read((0, react_1.useState)(customer === null || customer === void 0 ? void 0 : customer.email), 2), email = _u[0], setEmail = _u[1];
    var _v = __read((0, react_1.useState)(false), 2), isUsingPaypalExpressCheckout = _v[0], setUsingPaypalExpressCheckout = _v[1];
    var dataLayerPushEvent = function (eventName, params) {
        if (params === void 0) { params = {}; }
        DLEnhancedEcomm.pushEvent(eventName, {
            lineItems: cart.lineItems,
            priceShipping: shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price,
            discountCode: discountCode,
            priceSubtotal: priceSubtotal,
            priceTaxes: priceTaxes,
            priceTotal: priceTotal,
            priceDiscount: priceDiscount,
            phoneNumber: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phoneNumber,
            extras: params,
        });
    };
    var _w = __read((0, react_1.useState)(true), 2), loading = _w[0], setLoading = _w[1];
    var _x = __read((0, react_hooks_1.useMutation)(mutation_create_checkout_1.CREATE_OR_LOAD_CHECKOUT), 2), createOrLoadCheckoutMutation = _x[0], _y = _x[1], createCheckoutError = _y.error, isLoadingRechargeCheckout = _y.loading;
    var _z = __read((0, react_hooks_1.useMutation)(mutation_update_checkout_1.UPDATE_CHECKOUT), 2), updateCheckoutMutation = _z[0], _0 = _z[1], updateCheckoutError = _0.error, isUpdatingCheckout = _0.loading;
    var setShippingAddress = function (sa, overrides) { return __awaiter(void 0, void 0, void 0, function () {
        var mutationVars, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setShippingAddressState(sa);
                    if (billingSameAsShipping)
                        setBillingAddressState((0, pick_1.default)(sa, ['firstName', 'lastName', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phoneNumber']));
                    mutationVars = {
                        email: (overrides === null || overrides === void 0 ? void 0 : overrides.email) || email,
                        acceptsMarketing: overrides === null || overrides === void 0 ? void 0 : overrides.acceptsMarketing,
                        token: rechargeCheckoutToken,
                        shippingAddress: (0, transformers_1.convertAddressToRecharge)(sa),
                        billingAddress: (0, transformers_1.convertAddressToRecharge)(billingAddress || sa),
                    };
                    return [4 /*yield*/, updateCheckoutMutation({ variables: mutationVars })];
                case 1:
                    result = _b.sent();
                    if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCheckout)
                        setSubtotals(result.data.updateCheckout);
                    dataLayerPushEvent('checkout__shippingAddressAdded');
                    DLEnhancedEcomm.pushCheckoutStep(cart.lineItems, 2, sa.state);
                    return [2 /*return*/];
            }
        });
    }); };
    var setBillingAddress = function (ba) { return __awaiter(void 0, void 0, void 0, function () {
        var mutationVars, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setBillingAddressState(ba);
                    mutationVars = {
                        email: email,
                        token: rechargeCheckoutToken,
                        billingAddress: (0, transformers_1.convertAddressToRecharge)(ba),
                    };
                    return [4 /*yield*/, updateCheckoutMutation({ variables: mutationVars })];
                case 1:
                    result = _b.sent();
                    if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCheckout)
                        setSubtotals(result.data.updateCheckout);
                    dataLayerPushEvent('checkout__billingAddressChanged');
                    return [2 /*return*/];
            }
        });
    }); };
    var setDiscountCode = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        var mutationVars, result, response, em, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    mutationVars = { token: rechargeCheckoutToken, discountCode: code };
                    return [4 /*yield*/, updateCheckoutMutation({ variables: mutationVars })];
                case 1:
                    result = _b.sent();
                    response = (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCheckout;
                    if (!response) {
                        setDiscountCodeState(null);
                        setDiscountCodeError('There was an error applying this discount code');
                        return [2 /*return*/];
                    }
                    if (response.discount_code && response.applied_discount.applicable) {
                        dataLayerPushEvent('checkout__discountCodeAdded', { code: code });
                        setDiscountCodeState(code);
                        setDiscountCodeError(null);
                    }
                    else if (!response.discount_code) {
                        dataLayerPushEvent('checkout__discountCodeRemoved');
                        setDiscountCodeState(null);
                    }
                    else {
                        setDiscountCodeState(null);
                        dataLayerPushEvent('checkout__discountCodeError', { code: code, reason: response.applied_discount.non_applicable_reason });
                        em = discountCodeErrorMessagesDict[response.applied_discount.non_applicable_reason || 'default'] || discountCodeErrorMessagesDict.default;
                        setDiscountCodeError(em);
                    }
                    setSubtotals(response);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    if (err_1.graphQLErrors) {
                        setDiscountCodeError(discountCodeErrorMessagesDict.not_found || discountCodeErrorMessagesDict.default);
                        dataLayerPushEvent('checkout__discountCodeError', { code: code, reason: discountCodeErrorMessagesDict.not_found || discountCodeErrorMessagesDict.default });
                    }
                    else
                        throw err_1;
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setShippingMethod = function (sm) { return __awaiter(void 0, void 0, void 0, function () {
        var mutationVars, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setShippingMethodState(sm);
                    mutationVars = { shippingLineHandle: sm.handle, token: rechargeCheckoutToken };
                    return [4 /*yield*/, updateCheckoutMutation({ variables: mutationVars })];
                case 1:
                    result = _b.sent();
                    if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.updateCheckout)
                        setSubtotals(result.data.updateCheckout);
                    dataLayerPushEvent('checkout__shippingMethodSelected', { shippingMethod: sm.name || sm.title, shippingPrice: sm.price });
                    DLEnhancedEcomm.pushCheckoutStep(cart.lineItems, 3, sm.name);
                    return [2 /*return*/];
            }
        });
    }); };
    // This method is called if there is no shipping method available/needed. For example: when there is only a gift card in the cart.
    var markShippingMethodStepComplete = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dataLayerPushEvent('checkout__shippingMethodSelected', { giftCard: true });
            DLEnhancedEcomm.pushCheckoutStep(cart.lineItems, 3, 'No Delivery Method');
            return [2 /*return*/];
        });
    }); };
    var setStateFromRechargeCheckoutData = function (data) {
        var token = data.token;
        setRechargeCheckoutToken(token);
        localStorage.setItem(CHECKOUT_TOKEN_LOCALSTORAGE_KEY, token);
        setEmail(data.email);
        if (data.shipping_address) {
            setShippingAddressState((0, transformers_1.convertAddressFromRecharge)(data.shipping_address));
        }
        if (data.billing_address) {
            setBillingAddressState((0, transformers_1.convertAddressFromRecharge)(data.billing_address));
        }
        if (data.discount_code && data.applied_discount.applicable) {
            setDiscountCodeState(data.discount_code);
            // scrollRef = payRef
        }
        if (data.charge_id)
            setChargeId(data.charge_id);
        setSubtotals(data);
        setLoading(false);
    };
    var setSubtotals = function (data) {
        var _a;
        setPriceSubtotal(data.subtotal_price);
        setPriceDiscount((_a = data.applied_discount) === null || _a === void 0 ? void 0 : _a.amount);
        setPriceTaxes(data.total_tax);
        setPriceTotal(data.total_price);
    };
    var contextValue = {
        country: country,
        customer: customer,
        cart: cart,
        setShippingAddress: setShippingAddress,
        setBillingAddress: setBillingAddress,
        setBillingAddressState: setBillingAddressState,
        setBillingSameAsShipping: setBillingSameAsShipping,
        shippingAddress: shippingAddress,
        billingAddress: billingAddress,
        isLoadingRechargeCheckout: isLoadingRechargeCheckout,
        isPaypalEnabled: isPaypalEnabled,
        shippingMethod: shippingMethod,
        priceDiscount: priceDiscount,
        priceTotal: priceTotal,
        priceSubtotal: priceSubtotal,
        priceTaxes: priceTaxes,
        setShippingMethod: setShippingMethod,
        setChargeId: setChargeId,
        markShippingMethodStepComplete: markShippingMethodStepComplete,
        billingSameAsShipping: billingSameAsShipping,
        rechargeCheckoutToken: rechargeCheckoutToken,
        setRechargeCheckoutToken: setRechargeCheckoutToken,
        paymentProvider: paymentProvider,
        paymentAuthorizationToken: paymentAuthorizationToken || '',
        isPaymentValid: isPaymentValid,
        paymentInfo: paymentInfo,
        paymentMethod: paymentMethod,
        setDiscountCode: setDiscountCode,
        dataLayerPushEvent: dataLayerPushEvent,
        defaultMarketingFlag: defaultMarketingFlag,
        discountCode: discountCode,
        checkoutComplete: checkoutComplete,
        setCheckoutComplete: setCheckoutComplete,
        paypalCheckout: paypalCheckout,
        chargeId: chargeId,
        setPaymentValid: setPaymentValid,
        setPaymentInfo: setPaymentInfo,
        setPaymentMethod: setPaymentMethod,
        textStrings: textStrings || {},
        signupPageUrl: signupPageUrl,
        imageUrls: imageUrls || {},
        discountCodeError: discountCodeError,
        shippingMethodSubtext: shippingMethodSubtext || {},
        email: email,
        setEmail: setEmail,
        isUsingPaypalExpressCheckout: isUsingPaypalExpressCheckout,
        setUsingPaypalExpressCheckout: setUsingPaypalExpressCheckout,
    };
    var redirectToOldCheckout = function () {
        localStorage.removeItem(CHECKOUT_TOKEN_LOCALSTORAGE_KEY);
        // @ts-ignore
        window.top.location.href = window.getOldCheckoutUrl(process.env.PERMANENT_DOMAIN);
    };
    var loadPaypal = function () { return __awaiter(void 0, void 0, void 0, function () {
        var btClient, ppCheckout;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.debug('Loading paypal');
                    if (!paymentAuthorizationToken)
                        return [2 /*return*/];
                    return [4 /*yield*/, braintree_web_1.default.client.create({ authorization: paymentAuthorizationToken })];
                case 1:
                    btClient = _a.sent();
                    return [4 /*yield*/, braintree_web_1.default.paypalCheckout.create({ client: btClient })
                        // load the paypal JS into the window
                    ];
                case 2:
                    ppCheckout = _a.sent();
                    // load the paypal JS into the window
                    return [4 /*yield*/, ppCheckout.loadPayPalSDK({ vault: true })]; // TODO: update @types/braintree-web
                case 3:
                    // load the paypal JS into the window
                    _a.sent(); // TODO: update @types/braintree-web
                    setPayPalCheckout(ppCheckout);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // This section retrieves a checkout object from subless or creates one if it doesn't exist.
        // After loading the object, it sets up the state with the data, so the customer can resume the checkout.
        loadPaypal();
        if (cart.lineItems && cart.lineItems.length === 0)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var savedRechargeCheckoutToken, mutationVars, parsedQueryString, usingPaypalExpressCheckout, payload, config, pd, addr_1, fullState, r, err_2;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        savedRechargeCheckoutToken = localStorage.getItem(CHECKOUT_TOKEN_LOCALSTORAGE_KEY);
                        mutationVars = {
                            email: email || (customer === null || customer === void 0 ? void 0 : customer.email),
                            cartToken: cart.token,
                            lineItems: (0, transformers_1.convertShopifyLineItemsToRecharge)(cart.lineItems),
                            discountCode: window.discount,
                        };
                        if (savedRechargeCheckoutToken)
                            mutationVars.token = savedRechargeCheckoutToken;
                        parsedQueryString = querystring_1.default.parse((_a = window.location.search) === null || _a === void 0 ? void 0 : _a.replace(/^\?/, ''));
                        usingPaypalExpressCheckout = false;
                        if (parsedQueryString.pp) {
                            payload = JSON.parse(atob(parsedQueryString.pp));
                            config = localization_1.LocaleConfig[country];
                            dataLayerPushEvent('checkout__paypalExpressCheckoutApproved', {
                                shippingAddressPresent: !!payload.details.shippingAddress,
                                paypalCountry: (_c = (_b = payload.details) === null || _b === void 0 ? void 0 : _b.shippingAddress) === null || _c === void 0 ? void 0 : _c.countryCode,
                                paypalState: (_e = (_d = payload.details) === null || _d === void 0 ? void 0 : _d.shippingAddress) === null || _e === void 0 ? void 0 : _e.state,
                            });
                            if (((_f = payload.details.shippingAddress) === null || _f === void 0 ? void 0 : _f.countryCode) === country) {
                                pd = payload.details;
                                addr_1 = payload.details.shippingAddress;
                                fullState = config.states.find(function (s) { return s.abbreviation === addr_1.state; });
                                if (fullState && addr_1) {
                                    usingPaypalExpressCheckout = true;
                                    setPaymentMethod('paypal');
                                    setPaymentInfo({ cardType: 'paypal', email: payload.details.email, token: payload.nonce });
                                    setPaymentValid(true);
                                    mutationVars.shippingAddress = {
                                        first_name: pd.firstName,
                                        last_name: pd.lastName,
                                        address1: addr_1.line1,
                                        address2: addr_1.line2,
                                        city: addr_1.city,
                                        province: fullState.name,
                                        zip: addr_1.postalCode,
                                        phone: addr_1.phone || pd.phone || '8888606888',
                                        country: config.countryName,
                                    };
                                    mutationVars.billingAddress = {
                                        first_name: pd.firstName,
                                        last_name: pd.lastName,
                                        address1: addr_1.line1,
                                        address2: addr_1.line2,
                                        city: addr_1.city,
                                        province: fullState.name,
                                        zip: addr_1.postalCode,
                                        country: config.countryName,
                                        phone: addr_1.phone || pd.phone || '8888606888',
                                    };
                                    mutationVars.email = email || payload.details.email;
                                    mutationVars.acceptsMarketing = true;
                                }
                            }
                        }
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        console.debug(mutationVars);
                        return [4 /*yield*/, createOrLoadCheckoutMutation({ variables: mutationVars })];
                    case 2:
                        r = _g.sent();
                        (0, save_discount_for_checkout_1.removeDiscountCookie)();
                        if (!r.data || !r.data.checkoutLoadOrCreate) {
                            dataLayerPushEvent('checkout__errorRedirectToRecharge');
                            redirectToOldCheckout();
                            return [2 /*return*/];
                        }
                        setStateFromRechargeCheckoutData(r.data.checkoutLoadOrCreate);
                        dataLayerPushEvent('checkout__started');
                        DLEnhancedEcomm.pushCheckoutStep(cart.lineItems, 1);
                        setUsingPaypalExpressCheckout(usingPaypalExpressCheckout);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _g.sent();
                        console.error(err_2);
                        dataLayerPushEvent('checkout__errorRedirectToRecharge');
                        redirectToOldCheckout();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (react_1.default.createElement(exports.CheckoutContext.Provider, { value: contextValue },
        react_1.default.createElement(react_router_dom_1.HashRouter, null,
            !checkoutComplete && !!cart.lineItems.length && (react_1.default.createElement("div", { className: 'show-for-medium grid-x margin-bottom-4', style: { maxWidth: '1170px', margin: '0 auto' } },
                react_1.default.createElement("div", { className: 'cell medium-4 medium-offset-4' },
                    react_1.default.createElement(checkout_steps_1.default, null)))),
            react_1.default.createElement("div", { className: 'grid-x', style: { maxWidth: '1170px', margin: '0 auto' } },
                !checkoutComplete && (react_1.default.createElement("div", { className: 'cell small-12 medium-6 medium-order-2  medium-padding-horizontal-4 show-for-medium' },
                    react_1.default.createElement(order_summary_1.default, { expanded: false, expandable: true }))),
                react_1.default.createElement("div", { className: 'cell small-12 medium-6 medium-padding-horizontal-4' },
                    react_1.default.createElement("div", { className: 'checkout-container medium-padding-top-4' },
                        react_1.default.createElement("div", { className: 'hide-for-medium' }, !checkoutComplete && !!cart.lineItems.length && react_1.default.createElement(checkout_steps_1.default, null)),
                        !cart.lineItems.length && (react_1.default.createElement("div", { className: 'text-center height-100 flex-container align-center align-middle hide-for-medium margin-top-6' },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("img", { className: 'display-block padding-horizontal-4 large-padding-horizontal-10', src: window.cartSettings.empty_image, style: { width: '500px' } }),
                                react_1.default.createElement("div", { className: 'margin-bottom-4 font-bold h4 padding-horizontal-10 margin-top-6' }, window.cartSettings.empty_text),
                                react_1.default.createElement("a", { href: '/', className: 'button btn-form margin-bottom-2' }, "CONTINUE SHOPPING")))),
                        loading || isLoadingRechargeCheckout ? (react_1.default.createElement("div", { className: 'margin-top-4 padding-2 text-center' },
                            react_1.default.createElement(inline_loader_1.default, { isLoading: isLoadingRechargeCheckout, loadingText: "Please wait..." }))) : (react_1.default.createElement(react_router_dom_1.Switch, null,
                            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: '/payment', component: payment_1.default }),
                            react_1.default.createElement(react_router_dom_1.Route, { path: '/confirmation', component: confirmation_1.default }),
                            react_1.default.createElement(react_router_dom_1.Route, { path: '/', component: shipping_address_1.default })))))),
            react_1.default.createElement(scroll_to_top_1.default, null))));
});
